/**
 * Component homepage-slider JS
 *
 * !!! Uncomment only if component is needed, this way the compiler will ignore useless files
 */
 
jQuery(document).ready(function () {
    const component = jQuery('.homepage-slider');
    
    if (!component.length) {
        return;
    }

    jQuery('.homepage-slider .homepage-slider__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        //
        dots: false,
        //
        arrows: true,
        prevArrow: "",
        nextArrow: jQuery('.homepage-slider__arrows a'),
        //
        infinite: true,
        mobileFirst: true,
        variableWidth: false,
        //
        vertical: true,
        verticalSwiping: true,
        //
        // centerPadding: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                    variableWidth: true,

                }
            },
        ]
    });
});